import { createRouter, createWebHistory } from "vue-router";

import { ROUTES } from "./utils/enums";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: ROUTES.CHECKOUT,
      meta: { title: "checkoutFrontend.home", requiresAuth: false },
      component: () => import("./views/Checkout.vue"),
    },
  ],
});

export default router;
